/**
 * Видео-сообщение в TG-стиле: серверный poster (первый кадр) + большая
 * круглая play-кнопка + длительность в углу. Click → лайтбокс с реальным <video>.
 *
 * Никаких <video> в чате (раньше iOS Safari перехватывал тап и открывал
 * native fullscreen). Только <img> с серверным thumbnail'ом.
 */
import { useState } from "react";

import { chatVideoThumbnailUrl } from "@/api/dashboard";
import { Icon } from "@/components/prototype/Icon";
import { VideoLightbox } from "@/components/VideoLightbox";


function fmtDuration(sec: number | null | undefined): string | null {
  if (sec == null || !isFinite(sec) || sec <= 0) return null;
  const total = Math.round(sec);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}


export function VideoMessage({
  id, src, filename, durationSec, onOpen,
}: {
  id: number;
  src: string;
  filename?: string;
  durationSec?: number | null;
  /** Если задано — клик делегируется родителю (для общего media-лайтбокса
   *  с навигацией между картинками/видео). Иначе — внутренний лайтбокс без навигации. */
  onOpen?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [thumbFailed, setThumbFailed] = useState(false);
  const dur = fmtDuration(durationSec);

  return (
    <>
      <button
        type="button"
        className="chat-video-tg"
        data-att-id={id}
        onClick={(e) => {
          e.stopPropagation();
          if (onOpen) onOpen();
          else setOpen(true);
        }}
      >
        {!thumbFailed && (
          <img
            src={chatVideoThumbnailUrl(id)}
            alt=""
            className="chat-video-tg-poster"
            decoding="async"
            width={240}
            height={240}
            onError={() => setThumbFailed(true)}
            draggable={false}
          />
        )}
        {thumbFailed && <div className="chat-video-tg-poster chat-video-tg-poster-fallback"/>}
        {dur && <span className="chat-video-tg-duration">{dur}</span>}
        <span className="chat-video-tg-overlay">
          <span className="chat-video-tg-play">
            <Icon name="play" size={32}/>
          </span>
        </span>
      </button>
      {open && <VideoLightbox src={src} filename={filename} attachmentId={id} onClose={() => setOpen(false)}/>}
    </>
  );
}
